import { render } from "./TourGuideBanner.vue?vue&type=template&id=b1647b12"
import script from "./TourGuideBanner.vue?vue&type=script&lang=js"
export * from "./TourGuideBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__